angular.module('component-payments.format.name', [])
	.directive('ctPaymentsFormatName', paymentsFormatNameDirective);

function paymentsFormatNameDirective () {
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function (scope, elem, attr, ctrl) {
			var pos,
				elemDOM = elem[0];

			ctrl.$parsers.push(formatter);
			ctrl.$formatters.push(formatter);

			elem.on('keyup', function (e) {
				if (e.keyCode == 32)
					return;

				if (elemDOM.setSelectionRange) {
					pos = elemDOM.selectionStart;
				}

				elem.val(formatter(ctrl.$viewValue));

				if (elemDOM.setSelectionRange) {
					elemDOM.setSelectionRange(pos, pos)
				}
			});

			function formatter(val) {
				if (typeof val == 'string') {
					val = val.toUpperCase();
				}
				return val;
			}
		}
	}
}

module.exports = 'component-payments.format.name';


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/ct-payments/formatters/name.js
 ** module id = 93
 ** module chunks = 1
 **/